import Logo from "assets/images/Logo_launch_capital.svg";
import Poweredby from "assets/images/company-logo.png";
import favicon from "assets/images/Launch-capital-favicon.png";

const Initial = {
  branding: {
    favicon:favicon,
    logo: Logo,
    poweredbylogo: Poweredby,
  },
  organization:{
    name:"LCAF",
    title:"Launch Capital",
    description:"Home | Launch Capital",
  },
  theme: {
    textColor: "#333333",
    mainColor:"#21386C",    //set the header color of the table 
    darkColor:"#17274b",    // set the button color 
  },
  api:{
    baseUrl:""
  }
};

// Inject CSS variables directly into the document head
const setCSSVariables = () => {
  const style = document.createElement("style");
  style.innerHTML = `
    :root {
      --text-color: ${Initial.theme.textColor};
      --main-color: ${Initial.theme.mainColor};
      --dark-color: ${Initial.theme.darkColor};
      --background-color: ${Initial.theme.backgroundColor};
    }
  `;
  document.head.appendChild(style);
};

// Call the function to apply styles
setCSSVariables();
window.Initial = Initial;

export default Initial;
